import axios from "axios";

// const serverApi = "http://localhost:5002/api";
// const serverApi = "https://imed.serveis.in/api";
const serverApi = process.env.NODE_ENV === 'production' ? "https://imedapi.serveis.in/api" : "http://localhost:5002/api";


export const getRoomExists = async (roomId) => {
  const response = await axios.get(`${serverApi}/room-exists/${roomId}`);
  return response.data;
};

export const getTURNCredentials = async () => {
  const response = await axios.get(`${serverApi}/get-turn-credentials`);
  return response.data;
};

export const uploadFile = async (roomId, file) => {
  const formData = new FormData();
  formData.append("roomId", roomId);
  formData.append("file", file); // 'file' should be the actual file object
  console.log(`${serverApi}/upload`, formData);
  const response = await axios.post(`${serverApi}/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

